var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.82,
    height: 13.765,
    viewBox: "0 0 17.82 13.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-library-svgrepo-com_1_",
    "data-name": "video-library-svgrepo-com (1)",
    transform: "translate(0.4 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6878",
    "data-name": "Path 6878",
    d: "M13.9,13.287a.819.819,0,0,1,0,1.352l-2.869,1.779A.7.7,0,0,1,10,15.742V12.184a.7.7,0,0,1,1.029-.676Z",
    transform: "translate(-3.192 -7.657)",
    fill: "none",
    stroke: "#36abef",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6879",
    "data-name": "Path 6879",
    d: "M2.326,12.781c-.38-2.692-.569-4.038.237-4.91S4.806,7,7.678,7h5.664c2.872,0,4.308,0,5.115.871s.617,2.217.237,4.91l-.36,2.553c-.3,2.111-.446,3.167-1.21,3.8s-1.89.632-4.142.632H8.038c-2.252,0-3.378,0-4.142-.632s-.912-1.688-1.21-3.8Z",
    transform: "translate(-2 -7)",
    fill: "none",
    stroke: "#36abef",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVideo);
export default __webpack_public_path__ + "static/media/menuVideo.c4e0ee76307a4b954ff0e171ed8ff72c.svg";
export { ForwardRef as ReactComponent };